/**
 * returns input, or upper/lower bound if input exceeds either
 */
export const numClamp = (input: number, min: number, max: number): number => {
  return Math.min(Math.max(input, min), max);
};
